<template>
  <div id="init-page" class="screen">
    <app-icon
      name="oecko"
      size="large"
      desc="logo oecko"
      id="oecko-init-logo"/>
    <span id="message">Écran interactif OECKO</span>

    <div id="system-informations">
      <div class="information">
        <span class="info-title">Identification</span>
        <app-icon
            name="key"
            size="micro"
            desc="logo oecko" />
        <span class="info-details">
          <template v-if="deviceID">
            <span id="deviceID" :class="{ long: deviceID.length > 41 }">{{ deviceID }}</span>
          </template>
          <template v-else>
            <span>En attente</span>
          </template>
        </span>
      </div>
      <div class="information">
        <span class="info-title">Environnement serveur</span>
        <app-icon
            name="server"
            size="micro"
            desc="logo oecko" />
        <span class="info-details">{{ serverEnvironment }}</span>
      </div>
      <div class="information">
        <span class="info-title">Enregistrement serveur</span>
        <app-icon
            name="serverLink"
            size="micro"
            desc="logo oecko" />
        <span class="info-details">
          <template v-if="registration === 'process'">
            <Loader type="line" color="#1CB7F9"/>
          </template>
          <template v-else>
            {{ registration || 'En attente' }}
          </template>
        </span>
      </div>
      <div class="information">
        <span class="info-title">Affectation écran</span>
        <app-icon
            name="affectation"
            size="micro"
            desc="logo oecko" />
        <span class="info-details">
          <template v-if="affectation === 'process'">
            <Loader type="line" color="#1CB7F9"/>
          </template>
          <template v-else>
            {{ affectation || 'En attente' }}
          </template>
        </span>
      </div>
    </div>
    <div
      id="registration-keyboard"
      v-if="
        !registration
        || registration === 'En attente'
        || registration === 'L\'écran n\'est pas enregistré'
        || registration === 'Pas de réponse des serveurs Oecko'
        || registration === 'Pas de connexion internet'">
      <span class="keyboard-title">Choix de l'environnement</span>
      <div id="serverChoice">
        <div class="server-choice-button" :class="{ selected: serverChoice === 'dev' }">
          <input type="radio" id="dev" name="serverChoice" v-model="serverChoice" value="dev">
          <label for="dev">Developpement</label>
        </div>
        <div class="server-choice-button" :class="{ selected: serverChoice === 'prod' }">
          <input type="radio" id="prod" name="serverChoice" v-model="serverChoice" value="prod" checked>
          <label for="prod">Production</label>
        </div>
        <div class="server-choice-button" :class="{ selected: serverChoice === 'preprod' }">
          <input type="radio" id="preprod" name="serverChoice" v-model="serverChoice" value="preprod">
          <label for="preprod">Pré-production</label>
        </div>
      </div>
      <span class="keyboard-title">Code d'installation Oecko</span>
      <div id="installCodeContainer">
        {{ installCode }}
        <app-icon
          name="backspace"
          size="tiny"
          color="white"
          desc="retour"
          id="backspace"
          @click="removeNumber()"/>
      </div>
      <div id="keyboard">
        <button
          @click="addNumber(n)"
          class="keyboardBtn"
          v-for="n in 9"
          :key="n">{{ n }}
        </button>
        <button @click="addNumber(0)" class="keyboardBtn">0</button>
        <button @click="sendInstallCode()" class="keyboardBtn" id="send-button">&#10003;</button>
      </div>
    </div>
    <span id="init-page-title">OECKO</span>
    <span id="init-page-version">{{ version }}</span>
  </div>
</template>

<style lang="sass" scoped>
// --- PAGE ---------
#init-page
  align-items: center
  background: $dark-background
  display: flex
  flex-direction: column
  padding-top: 8rem
#init-page-title
  bottom: 1.3rem
  color: $oecko-text-light
  font-family: 'RobotoLight'
  font-size: .8em
  position: absolute
#init-page-version
  bottom: 1.3rem
  color: $oecko-text-light
  font-family: 'RobotoThin'
  font-size: .4em
  position: absolute
  right: 2rem

// --- HEADER ---------
#oecko-init-logo
  color: $oecko-color-main
#message
  color: $oecko-text-light
  font-family: 'RobotoLight'
  font-size: .8em
  margin-top: 1.2rem

// --- START-PROCESSES ---------
#system-informations
  color: #fff
  display: flex
  flex-direction: column
  margin-top: 5rem
  width: 70vw
  .information
    align-items: center
    display: flex
    justify-content: center
    margin: .2rem 0
    .info-title
      display: flex
      flex: 9
      font-family: 'RobotoThin'
      font-size: .55em
      justify-content: flex-end
    .info-details
      flex: 9
      font-family: 'RobotoLight'
      font-size: .55em
      justify-content: flex-start
      #deviceID
        font-size: .75em
        &.long
          font-size: .45em
    svg
      color: $oecko-color-main
      flex: 1
      margin: 0 1rem

// --- REGISTRATION-KEYBOARD ---------
#registration-keyboard
  align-items: center
  color: #fff
  display: flex
  flex-direction: column
  margin-top: 5rem
  padding: 0 0 1.5rem 0
  position: relative
.keyboard-title
  font-family: 'RobotoLight'
  font-size: .5em
  margin: 2.3rem 0 1rem 0
#serverChoice
  align-items: center
  display: flex
  font-family: 'RobotoThin'
  font-size: .5em
  justify-content: space-around
  .server-choice-button
    align-items: center
    border-radius: 3px
    display: flex
    flex-direction: column
    margin: .4rem
    padding: .2rem
    width: 11rem
    &.selected
      color: $oecko-color-main
      font-family: 'RobotoRegular'
      fon-size: .55em
#installCodeContainer
  align-items: center
  border-bottom: 1px solid #aaa
  display: flex
  font-family: 'RobotoRegular'
  font-size: .9em
  justify-content: center
  height: 4rem
  letter-spacing: .1em
  position: relative
  text-align: center
  width: 24rem
  #backspace
    position: absolute
    right: 0
#keyboard
  display: flex
  flex-wrap: wrap
  justify-content: center
  position: relative
  width: 30rem
.keyboardBtn
  background: none
  border: none
  color: #fff
  font-family: 'RobotoThin'
  font-size: 1em
  height: 7rem
  outline: none
  width: 10rem
#send-button
  bottom: 0
  color: $oecko-color-main
  position: absolute
  right: 0
#registration-notification
  align-items: center
  background: rgba(183,28,28, .6)
  bottom: 0
  border-radius: 0 0 6px 6px
  display: flex
  left: 0
  position: absolute
  right: 0
  #notification-icon
    margin: 0 1rem
  #notification-message
    font-family: 'RobotoLight'
    font-size: .6em
</style>

<script>
import { mapGetters } from 'vuex';
import AppIcon from '@/components/icons/AppIcon.vue';
import Loader from '@/components/appModules/Loader.vue';

export default {
  name: 'Init',

  components: {
    AppIcon,
    Loader,
  },

  data() {
    return {
      affectation: null,
      deviceID: null,
      initWorker: null,
      installCode: null,
      registration: null,
      serverChoice: 'prod',
      serverUrl: null,
      version: process.env.VUE_APP_VERSION,
    };
  },

  computed: {
    ...mapGetters({
    }),
    serverEnvironment() {
      let environment;
      if (this.serverUrl === 'http://localhost:8000') environment = 'Développement local';
      else if (this.serverUrl === 'https://app.oecko.com') environment = 'Production';
      else if (this.serverUrl === 'https://preprod.app.oecko.com') environment = 'Pré-production';
      else if (this.serverUrl === 'https://dev.app.oecko.com') environment = 'Développement';
      else environment = 'En attente';

      return environment;
    },
  },

  created() {
    this.initWorker = new Worker('@/worker.js', { type: 'module' });

    this.initWorker.onmessage = e => {
      if (e.data.action === 'processRegistrationResult') {
        console.log(e.data.registrationResult);
        switch (e.data.registrationResult.status) {

          case 'NOT_REGISTERED':
            this.registration = 'L\'écran n\'est pas enregistré';
            break;

          case 'OECKO_SERVER_DOWN':
            if (this.installCode) {
              this.registration = 'Pas de réponse des serveurs Oecko';
              this.installCode = null;
            } else {
              this.registration = 'En attente des serveurs Oecko';
              this.screenRegistration(120000);
            }
            break;

          case 'NO_INTERNET':
            if (this.installCode) {
              this.registration = 'Pas de connexion internet';
              this.installCode = null;
            } else {
              this.registration = 'En attente de connection internet';
              this.screenRegistration(120000);
            }
            break;

          case 'REGISTRATION_FAILED':
            this.registration = 'Code d\'installation invalide';
            this.installCode = null;
            break;

          case 'REGISTRATION_SUCCESSFUL':
            this.registration = this.version;
            this.installCode = null;
            localStorage.setItem(
              'registrationData',
              JSON.stringify({ registeredVersion: this.version }));

            if (!this.deviceID && !this.serverUrl) {
              localStorage.setItem(
              'initConfig',
              JSON.stringify({
                deviceID: e.data.registrationResult.token ,
                serverUrl: e.data.registrationResult.serverUrl
              }));
              this.deviceID = e.data.registrationResult.token;
              this.serverUrl = e.data.registrationResult.serverUrl;
            }

            this.screenAffectation();
            break;

          default:
            this.registration = 'Une erreur s\'est produite';
            break;
        }
      } else if (e.data.action === 'processAffectationResult') {
        console.log(e.data.affectationResult);
        switch (e.data.affectationResult.status) {
          
          case 'AFFECTATION_FOUND':
            this.affectation =
              `${e.data.affectationResult.entranceConfig.residenceName} - ${e.data.affectationResult.entranceConfig.entranceName}`;
            localStorage.setItem(
              'entranceConfig',
              JSON.stringify(e.data.affectationResult.entranceConfig)
            );

            const data = localStorage.getItem('contents_data')
              ? JSON.parse(localStorage.getItem('contents_data'))
              : {};

            const recoveryData = localStorage.getItem('contents_recoveryData')
              ? JSON.parse(localStorage.getItem('contents_recoveryData'))
              : {};

            
            data.oecko = e.data.affectationResult.contents_data.oecko;
            recoveryData.oecko = {};
            recoveryData.oecko.validityDate = e.data.affectationResult.contents_recoveryData.oecko.validityDate;
            recoveryData.oecko.updateToken = e.data.affectationResult.contents_recoveryData.oecko.updateToken;
            recoveryData.oecko.deviceID = JSON.parse(localStorage.getItem('initConfig')).deviceID;
            recoveryData.oecko.serverUrl = JSON.parse(localStorage.getItem('initConfig')).serverUrl;

            localStorage.setItem(
              'contents_data',
              JSON.stringify(data)
            );
            localStorage.setItem(
              'contents_recoveryData',
              JSON.stringify(recoveryData)
            );

            this.$router.push({
              name: 'launcher',
            });
            break;

          case 'NOT_AFFECTED':
            this.affectation = 'process';
            this.screenAffectation(90000);
            break;
          
          case 'NOT_REGISTERED':
            this.affectation = null;
            this.registration = 'L\'écran n\'est pas enregistré';
            localStorage.removeItem('registrationData');
            break;

          case 'NO_INTERNET':
            this.affectation = 'En attente de connexion internet';
            this.screenAffectation(150000);
            break;

          case 'OECKO_SERVER_DOWN':
            this.affectation = 'En attente des serveurs Oecko';
            this.screenAffectation(150000);
            break;
        
          default:
             this.registration = 'Une erreur s\'est produite';
             this.screenAffectation(150000);
            break;
        }
      }
    };
  },

  mounted() {
    this.deviceID = localStorage.getItem('initConfig')
      ? JSON.parse(localStorage.getItem('initConfig')).deviceID
      : null;
    this.serverUrl = localStorage.getItem('initConfig')
      ? JSON.parse(localStorage.getItem('initConfig')).serverUrl
      : null;
    this.registration = localStorage.getItem('registrationData')
      ? JSON.parse(localStorage.getItem('registrationData')).registeredVersion
      : null;

    if (this.$route.params.operation === 'registration') {
      this.registration = 'process';
      this.screenRegistration();
    } else if (this.$route.params.operation === 'affectation') {
      this.screenAffectation();
    }
  },

  beforeDestroy() {
    console.log('quitte init');
    this.initWorker.terminate();
    this.initWorker = null;
  },

  methods: {
    addNumber(n) {
      let code = this.installCode || '';
      code = code.length < 8 ? code += `${n}` : code;
      this.installCode = code;
    },

    removeNumber() {
      if (this.installCode.length > 0) this.installCode = this.installCode.slice(0, -1);
    },

    sendInstallCode() {
      this.registration = 'process';
      let serverUrl = '';
      switch (this.serverChoice) {
        case 'prod':
          serverUrl = process.env.VUE_APP_PROD_SERVER_URL;
          break;
        case 'preprod':
          serverUrl = process.env.VUE_APP_PREPROD_SERVER_URL;
          break;
        case 'dev':
          serverUrl = process.env.VUE_APP_DEV_SERVER_URL;
          break;
        default:
      }

      if (!this.installCode || this.installCode === '') {
        this.registration = 'Code d\'installation invalide';
      } else {
        this.screenRegistration(0, this.installCode);
      }
    },

    screenRegistration(delay = 0, installCode = null) {
      const deviceID = JSON.parse(localStorage.getItem('initConfig')).deviceID;
      const serverUrl = JSON.parse(localStorage.getItem('initConfig')).serverUrl;

      this.initWorker.postMessage({
        action: 'screenRegistration',
        params: {
          deviceID,
          serverUrl,
          version: this.version,
          delay,
          installCode,
        }
      });
    },

    screenAffectation(delay = 0) {
      const deviceID = JSON.parse(localStorage.getItem('initConfig')).deviceID;
      const serverUrl = JSON.parse(localStorage.getItem('initConfig')).serverUrl;

      this.affectation = 'process';
      this.initWorker.postMessage({
        action: 'screenAffectation',
        params: { deviceID, serverUrl, delay },
      });
    },
  },
};
</script>
